// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"TextArea_textAreaContainer__v98DK","textArea":"TextArea_textArea__h8J6T","label":"TextArea_label__4uA-G","error":"TextArea_error__V0uRz"};